import React from 'react';
import Button from '@material-ui/core/Button';
import ModalHead from './ModalHead';
import Typography from '@material-ui/core/Typography';
import CopyrightIcon from '@material-ui/icons/Copyright';
import {Styles} from './Styles';

interface Props {
    close():void,
}

const Guide = (props:Props)=> {
    const classes = Styles.base();

    return (
        <div id="confirm" className={classes.modalRoot}>
            <ModalHead close={props.close}/>
            <Typography variant="subtitle1" className={classes.subtitle1}>Apart？</Typography>
            <div style={{marginBottom:"2em"}}>
                「アパート」と読みます。
            </div>
            <Typography variant="subtitle1" className={classes.subtitle1}>クレジット</Typography>
            <div style={{marginBottom:"2em"}}>
                ・このゲームはレトロインクが作成しました。<br/>
                ・レトロインクは、プレイヤーがこのゲームに入力したテキストを、このゲームおよび派生する関連コンテンツ内において自由に使用する権利を有します。<br/>
            </div>
            <div style={{textAlign:"center",marginBottom:"4em"}}>
                Apart<br/>
                ver.20190903<br/>
                <br/>
                <span className={classes.withIcon} ><CopyrightIcon/>レトロインク　2019</span><br/>
                <a href="https://goisagi.retro-ink.com/" target="_blank" className="tw" rel="noopener noreferrer" style={{textDecoration:"none"}}>https://goisagi.retro-ink.com/</a>
            </div>
            <Button variant="outlined" color="default" style={{width:"100%",marginBottom:"2em"}} onClick={props.close}>閉じる</Button>
        </div>
    );
}

export default Guide;
